/*
 * Copyright (c) 2018-2026 Anton Prokhorov. All rights reserved.
 * This software is the confidential and proprietary information of the author.
 * Unauthorized copying, modification, or distribution is strictly prohibited.
 *
 */

import CatalogList from "../components/Catalogs/CatalogList";
import {PERM} from "../utilites/permissions";

const catalogList = [
  {
    path: '/catalogs',
    name: 'CatalogList',
    component: CatalogList,
    meta: {requiresAuth: true,
      permissions: [
        PERM.CATALOG,
      ]
    },
    props: true,
  },
];

export default catalogList;



// WEBPACK FOOTER //
// ./src/router/catalogList.js